/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Pit3_TInputs */

const en_to_csv_pit3_t = /** @type {(inputs: To_Csv_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel on Windows may garble non ASCII text`)
};

const ko_to_csv_pit3_t = /** @type {(inputs: To_Csv_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows의 Excel이 비ASCII 텍스트를 깨뜨릴 수 있습니다`)
};

const ja_to_csv_pit3_t = /** @type {(inputs: To_Csv_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows の Excel は非 ASCII テキストを壊すことがあります`)
};

/**
* | output |
* | --- |
* | "Excel on Windows may garble non ASCII text" |
*
* @param {To_Csv_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_pit3_t = /** @type {((inputs?: To_Csv_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_pit3_t(inputs)
	if (locale === "ko") return ko_to_csv_pit3_t(inputs)
	return ja_to_csv_pit3_t(inputs)
});